import { conditionStringTypeEnum, conditionStringOperatorEnum, logicalOrConditionTypeEnum } from '@proposify/users-bff-api-client';
import type { RolePermission } from '@proposify/users-bff-api-client';

export type ApproverConditions = NonNullable<RolePermission['conditions']>;

// The approver list has no dedicated API field — it's the existing generic permission
// conditions mechanism applied to document_approval_required: a single ConditionString
// for one approver, or a logical_or of them for several. See users-service PR #856.
const buildApproverCondition = (userId: string): ApproverConditions[number] => ({
  type: conditionStringTypeEnum.string,
  inputName: 'userId',
  operator: conditionStringOperatorEnum.equals,
  value: userId,
});

export const buildApproverConditions = (userIds: string[]): ApproverConditions | undefined => {
  if (userIds.length === 0) return undefined;
  if (userIds.length === 1) return [buildApproverCondition(userIds[0])];
  return [{ type: logicalOrConditionTypeEnum.logical_or, conditions: userIds.map(buildApproverCondition) }];
};

export const parseApproverUserIds = (conditions?: ApproverConditions): string[] =>
  (conditions ?? []).flatMap((condition) => {
    if (condition.type === conditionStringTypeEnum.string && condition.inputName === 'userId') return [condition.value];
    if (condition.type === logicalOrConditionTypeEnum.logical_or) return parseApproverUserIds(condition.conditions);
    return [];
  });
